<div style="display: flex; flex-direction:column; align-items: center; justify-content: center; width: 100%; height: 100%;">
    <div style="display: flex;">
      <div style="width: 100%">
        
        <div class="logo">
          <img src="assets/logo.png" style="max-height: 35px" alt="Logo">
        </div>

        <h1 style="font-size: 1.5rem">RESPECT Coaching Styles™ Assessment</h1>
         
      </div>
    </div>

    <div  style="width: 500px; text-align: center;" class="subtext">
      <p>Take the only research-backed assessment that makes you an instantly better coach. In just 7 minutes, gain deep insights into your coaching strengths and weaknesses with this award-winning tool.</p>
    </div>

  
    <lib-content-loader *ngIf="loading"></lib-content-loader>
    <div *ngIf="!loading " [formGroup]="form" style="margin-top: 1rem; width: 500px">

      <div>
        <mat-form-field actions appearance="outline" style="width: 100%;">
          <mat-label>First Name</mat-label>
          <input matInput type="text" formControlName="first_name" required>
          <mat-error *ngIf="form.get('first_name')?.errors">
            First name is required.
          </mat-error>
        </mat-form-field>
      </div>
  
      <div>
        <mat-form-field actions appearance="outline" style="width: 100%;">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" formControlName="last_name" required>
          <mat-error *ngIf="form.get('last_name')?.errors">
            Last name is required.
          </mat-error>
        </mat-form-field>
      </div>
  
      <div>
        <mat-form-field actions appearance="outline" style="width: 100%;">
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="email_address" required>
          <mat-error *ngIf="form.get('email_address')?.errors">
            Email Address is required.
          </mat-error>
        </mat-form-field>
      </div>
  
      <div>
        <mat-form-field actions appearance="outline" style="width: 100%;">
          <mat-label>Organization Name</mat-label>
          <input matInput type="text" formControlName="org_name" >
        </mat-form-field>
      </div>
  
      <div style="width: 100%; text-align: center;">
        <lib-button color="primary" 
          mat-button [disabled]="!form.valid"
          (click)="checkout()"
        >
          Next
        </lib-button>
      </div>
  
    </div>
  
  </div>